import React from 'react';
import { PanelSectionContent } from 'src/components/ui/odfjellPanel/OdfjellPanel.styles';
import OdfjellInputComponent, { InputChangeData } from 'src/components/common/odfjell-input-component/OdfjellInputComponent';
import Tooltip from 'src/components/ui/tooltip/Tooltip';
import { RotationPortCall } from 'src/types/ViewModel/Stowage/Rotation/RotationPortCall';
import { RotationBerthCall } from 'src/types/ViewModel/Stowage/Rotation/RotationBerthCall';

interface ReportPanelBerthSelectorProps {
    selectedStowageRotationPortCall: RotationPortCall | null;
    selectedBerthReportsBerthCall: RotationBerthCall | null;
    setSelectedBerthReportsBerthCall: (berthCall: RotationBerthCall | null) => void;
}

/**
 * Lets the user pick which single berth within the currently selected port call the Berth
 * reports tab (both its Tank plan and Manifest sections) should be scoped to. No berth is
 * pre-selected - the user must actively choose one via the "Select berth..." placeholder before
 * any report checkbox in this tab becomes selectable.
 */
const ReportPanelBerthSelector: React.FC<ReportPanelBerthSelectorProps> = ({
    selectedStowageRotationPortCall,
    selectedBerthReportsBerthCall,
    setSelectedBerthReportsBerthCall,
}) => {
    const _berthCalls = (selectedStowageRotationPortCall?.berthCalls || [])
        .slice()
        .sort((a, b) => a.berthSequenceNumber - b.berthSequenceNumber);

    const _berthOptions = _berthCalls.map((berthCall) => ({
        value: berthCall.berthCallGuid as unknown as string,
        label: berthCall.berthName || `Berth ${berthCall.berthSequenceNumber}`,
    }));

    const handleChange = (changeObject: InputChangeData) => {
        const _selectedGuid = changeObject.event?.target?.value;
        const _berthCall = _berthCalls.find((berthCall) => (berthCall.berthCallGuid as unknown as string) === _selectedGuid);
        setSelectedBerthReportsBerthCall(_berthCall || null);
    };

    return (
        <PanelSectionContent>
            <Tooltip text="Select the berth these reports (Tank plan and Manifest) should be scoped to." type="information">
                <OdfjellInputComponent
                    type="select"
                    name="berthReportsBerthSelector"
                    options={_berthOptions}
                    selectDefaultOption="Select berth..."
                    value={(selectedBerthReportsBerthCall?.berthCallGuid as unknown as string) || ''}
                    onChange={handleChange}
                    isReadOnly={_berthCalls.length === 0}
                    textAlign="left"
                />
            </Tooltip>
        </PanelSectionContent>
    );
};

export default ReportPanelBerthSelector;
